module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA6.51879158.jpg";